import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterReviewer } from '@/api/model/interfaces';

export default class RegisterReviewerOdata extends OdataManager<RegisterReviewer> {}
